import createVueComponent from '../createVueComponent';

const Clock10 = createVueComponent('Clock10Icon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['polyline', { points: '12 6 12 12 8 10' }],
]);

export default Clock10;
